<bizz-permissions [data]="data"  (onClose)="removeFromViewStack($event)"></bizz-permissions>